export function fieldOptionsToDropdownItems(
  options: string[] = [],
): { label: string; value: string }[] {
  return options.map((option) => ({
    label: option,
    value: option,
  }));
}
